<template>
  <div class="contenedor-cpanel">
    <BaseNotification2
      v-if="store.status.msg != null"
      :type="store.status.type"
      :text="store.status.msg"
      :closable="store.status.closable"
      @close="borrarNotificacion()"
    />
    <div class="contenedor-titulo">
      <h1>Listado de Mentorías</h1>
      <div class="barra"></div>
    </div>
    <section class="contenedor-c">
      <div class="contenedor_boton_crear_mentor">
        <router-link to="/mentores" class="boton-crear-mentor">Mentores Habilitados</router-link>
      </div>
      <MentoriasLista
      ></MentoriasLista>
    </section>
  </div>
</template>

<script>
import store from '../store'
import BaseNotification2 from '../components/BaseNotification2'
import MentoriasLista from '../components/MentoriasLista.vue'
export default {
  name: 'MentoriasListado',
  components: {
    MentoriasLista,
    BaseNotification2
  },
  data: function () {
    return {
      store
    }
  },
  methods: {
    borrarNotificacion () {
      this.store.setStatus({
        msg: null,
        type: null,
        title: null
      })
    }
  },
  mounted: function () {
    setTimeout(() => {
      this.borrarNotificacion()
    }, 4000)
  }
}
</script>

<style>

</style>
